import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const DashboardMembershipChart = ({ membersInfo }) => {
  const rows = membersInfo || [];
  const data = {
    labels: rows.map((item) => item.label),
    datasets: [
      {
        label: "Active memberships",
        data: rows.map((item) => item.count),
        backgroundColor: [
          "rgba(211, 24, 65)",
          "rgba(23, 94, 141)",
          "rgba(161, 126, 35)",
          "rgba(24, 133, 133)",
          "rgba(74, 42, 139)",
        ],
        borderColor: [
          "rgb(167, 36, 64)",
          "rgb(26, 97, 145)",
          "rgb(163, 126, 32)",
          "rgb(40, 185, 185)",
          "rgb(97, 54, 184)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
  };

  return (
    <div
      style={{
        width: "100%",
        padding: '12px',
        background: "#F1F1F8",
        borderRadius: "10px",
        boxShadow: "0 0 10px #ccc",
        marginTop: 0,
      }}
    >
      <h5 className="membership-chart-title">Active Membership Mix</h5>
      <div className="membership-chart">
        {rows.length > 0 ? (
          <Pie data={data} options={options} />
        ) : (
          <p>No active memberships found</p>
        )}
      </div>
    </div>
  );
};

export default DashboardMembershipChart;
